import React from "react";
import { useNavigate } from "react-router-dom";
import "./CategoryCard.css";
import { Typography } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useTranslation } from "react-i18next";

const REACT_APP_STATIC_URL = process.env.REACT_APP_STATIC_URL;

const CategoryCard = ({ category, compact }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  console.log(category);

  function getImgPath() {
    if (category) {
      return `${REACT_APP_STATIC_URL}/${category.imgPath}`;
    }
    return "";
  }

  return (
    <div className="category-card">
      <Typography variant="h5" sx={{ color: "#439BD9", fontWeight: "700", fontSize: "29px", }}>
        {t(`category.${category?.name}`)}
      </Typography>
      <img
        className="category-img"
        src={getImgPath()}
        alt={category?.name || ""}
      />
      <div className="module-entries">
        {category?.modules.map((module) => (
          <div
            className={`module-entry ${
              module.isReleased ? "not-released" : ""
            }`}
            key={module.id}
          >
            <Typography
              variant="h6"
              sx={{ cursor: "pointer", letterSpacing: "2%", }}
              onClick={() => {
                // Check if the module is released
                if (module.isReleased) {
                  // Navigate to the module page
                  navigate(`/new-check/${category.uriName}/${module.uriName}`);
                } else {
                  console.log("Module is not released yet");
                }
              }}
            >
              {module.isReleased ? (
                <div className="module-entry-released">
                  {module?.icon}
                  <span style={{ fontSize: "18px", color: "" }}>
                    {" "}
                    {t(`module.${module.name}`)}
                  </span>
                </div>
              ) : (
                <div className="module-entry-in-development">
                  <span style={{ fontSize: "18px" }}>
                    {t(`module.${module.name}`)} ({t("inOntwikkeling")})
                  </span>
                </div>
              )}
            </Typography>
            <ArrowForwardIcon
              onClick={() => {
                module.isReleased &&
                  navigate(`/new-check/${category.uriName}/${module.uriName}`);
              }}
              sx={{
                cursor: module.isReleased ? "pointer" : "not-allowed",
                color: module.isReleased ? "#439BD9" : "#C1C1C1",
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default CategoryCard;
